import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  button: {
    position: "absolute",
    elevation: 5,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    width: "6.5vmax",
    height: "6.5vmax",
    borderRadius: "6.5vmax",
    backgroundColor: "$nav_button_circle",
    justifyContent: "center",
  },
  left: {
    left: "3vw",
    paddingLeft: "2.1vmax",
  },
  right: {
    right: "3vw",
    paddingLeft: "2.8vmax",
  },
  "@media (max-width: 500)": {
    left: {
      left: 2,
    },
    right: {
      right: 2,
    },
  },
  icon: {
    fontSize: "4.5vmax",
    color: "$nav_button_arrow",
  },
  image: {
    width: "8vmax",
    height: "8vmax",
  },
});
